var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x95\x84\xEC\x9D\xB4\xEC\xBD\x98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6757 0.461914H2.32413C1.04028 0.461914 -0.000488281 1.50268 -0.000488281 2.78653V13.2133C-0.000488281 14.4971 1.04028 15.5379 2.32413 15.5379H15.6757C16.9595 15.5379 18.0003 14.4971 18.0003 13.2133V2.78653C18.0003 1.50268 16.9595 0.461914 15.6757 0.461914Z",
    fill: "url(#paint0_linear_201_936)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.38152 4.27143C8.66133 3.7913 7.8011 3.51123 6.87285 3.51123C4.37619 3.51123 2.34766 5.53977 2.34766 8.03643C2.34766 10.5331 4.37619 12.5616 6.87285 12.5616C7.8011 12.5616 8.66133 12.2816 9.38152 11.8014V12.3856H11.4381V3.68728H9.38152V4.27143ZM6.87285 10.5051C5.51249 10.5051 4.4042 9.39679 4.4042 8.03643C4.4042 6.67607 5.51249 5.56777 6.87285 5.56777C8.23321 5.56777 9.34151 6.67607 9.34151 8.03643C9.34151 9.39679 8.23321 10.5051 6.87285 10.5051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4115 3.50708H13.355V12.5575H15.4115V3.50708Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_936",
    x1: 1.41189,
    y1: 15.5859,
    x2: 16.5879,
    y2: 0.409898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#07E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#13BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1D9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2483FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2875FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2A71FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A76FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2A84F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2A9CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2BBED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CE9C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.140d5c2a11968f5832813c34fc6c213e.svg";
export { ForwardRef as ReactComponent };